var _metadata, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgCarClipboard = function SvgCarClipboard(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsdc: "http://purl.org/dc/elements/1.1/",
    xmlnscc: "http://creativecommons.org/ns#",
    xmlnsrdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnssvg: "http://www.w3.org/2000/svg",
    viewBox: "0 0 816 1056",
    height: 130,
    width: 130,
    xmlSpace: "preserve",
    id: "svg2",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata8"
  }, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfabout: ""
  }, /*#__PURE__*/React.createElement("dcFormat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dcType", {
    rdfresource: "http://purl.org/dc/dcmitype/StillImage"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath18",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path16",
    d: "M 0,792 H 612 V 0 H 0 Z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333333,0,0,-1.3333333,0,1056)",
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath18)",
    id: "g14"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(154.6055,274.3213)",
    id: "g20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path22",
    style: {
      fill: "current",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 h -29.387 c -4.436,0 -8.064,3.629 -8.064,8.063 V 25.786 H 8.064 V 8.063 C 8.064,3.629 4.435,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(131.8047,348.1631)",
    id: "g24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path26",
    style: {
      fill: "current",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,-7.033 4.688,-12.894 10.158,-16.019 5.47,-3.126 22.27,-3.516 30.084,-2.344 7.814,1.173 12.893,9.377 6.641,16.409 C 40.632,5.079 27.098,10.02 14.065,14.064 0.22,18.362 0,7.032 0,0 m 4.59,59.598 c 16.368,33.22 23.592,47.095 38.185,56.967 13.138,8.887 31.119,9.492 53.885,10.259 2.431,0.082 4.923,0.165 7.475,0.261 l 0.369,-9.793 c -2.566,-0.096 -5.07,-0.181 -7.515,-0.263 C 75.8,116.316 59.064,115.752 48.266,108.448 36.593,100.55 30.266,89.447 14.759,58.059 l 89.166,2.499 V -39.852 H -8.596 c 0,0 -8.986,2.736 -13.283,12.894 -4.298,10.158 -11.546,32.428 -10.462,43.367 1.085,10.94 6.945,19.926 18.276,26.958 0,0 -6.251,1.563 -11.331,4.689 -5.079,3.125 -8.42,4.688 -6.945,10.158 1.476,5.47 4.601,6.641 4.601,6.641 h 19.144 c 0,0 8.987,-5.469 8.596,-9.376 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(416.4658,274.582)",
    id: "g28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path30",
    style: {
      fill: "current",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 h -162.217 c -5.867,0 -10.64,4.772 -10.64,10.64 v 198.551 c 0,5.868 4.773,10.641 10.64,10.641 h 30.709 v -11.2 h -30.149 V 11.199 H -0.56 v 197.433 h -31.32 v 11.2 H 0 c 5.868,0 10.641,-4.773 10.641,-10.641 V 10.64 C 10.641,4.772 5.868,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(374.8184,477.4834)",
    id: "g32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path34",
    style: {
      fill: "current",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 h -79.312 v 22.27 h 27.349 l 12.893,-9.768 11.33,9.768 H 0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(343.9297,502.0972)",
    id: "g36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path38",
    style: {
      fill: "current",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,4.727 -3.846,8.572 -8.572,8.572 -4.727,0 -8.573,-3.845 -8.573,-8.572 0,-4.726 3.846,-8.571 8.573,-8.571 C -3.846,-8.571 0,-4.726 0,0 m 7.056,0 c 0,-8.631 -6.997,-15.627 -15.628,-15.627 -8.631,0 -15.628,6.996 -15.628,15.627 0,8.631 6.997,15.628 15.628,15.628 C 0.059,15.628 7.056,8.631 7.056,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(309.3965,419.042)",
    id: "g40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path42",
    style: {
      fill: "current",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 H -42.651 V 42.651 H 0 v -6.87 h -2.8 v 4.07 H -39.852 V 2.8 H -2.8 V 17.809 H 0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(289.3794,431.2612)",
    id: "g44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path46",
    style: {
      fill: "current",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 -11.067,12.396 c -0.773,0.865 -0.698,2.192 0.168,2.965 0.865,0.773 2.193,0.697 2.965,-0.168 L 0.533,5.709 24.381,24.054 c 0.92,0.706 2.238,0.535 2.946,-0.384 0.707,-0.92 0.535,-2.237 -0.384,-2.945 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(309.3965,364.1816)",
    id: "g48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path50",
    style: {
      fill: "current",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 H -42.651 V 42.65 H 0 v -6.869 h -2.8 v 4.07 H -39.852 V 2.8 H -2.8 V 17.809 H 0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(289.3794,376.4004)",
    id: "g52"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path54",
    style: {
      fill: "current",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 -11.067,12.396 c -0.773,0.866 -0.698,2.193 0.168,2.965 0.865,0.774 2.193,0.697 2.965,-0.168 L 0.533,5.71 24.381,24.055 c 0.92,0.706 2.238,0.535 2.946,-0.385 0.707,-0.919 0.535,-2.237 -0.384,-2.944 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(309.3965,309.3213)",
    id: "g56"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path58",
    style: {
      fill: "current",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 H -42.651 V 42.65 H 0 v -6.869 h -2.8 v 4.07 H -39.852 V 2.8 H -2.8 V 17.809 H 0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(289.3794,321.54)",
    id: "g60"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path62",
    style: {
      fill: "current",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 -11.067,12.396 c -0.773,0.865 -0.698,2.193 0.168,2.965 0.865,0.774 2.193,0.697 2.965,-0.168 L 0.533,5.71 24.381,24.055 c 0.92,0.706 2.238,0.535 2.946,-0.385 0.707,-0.919 0.535,-2.237 -0.384,-2.944 z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path64",
    style: {
      fill: "current",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 406.073,457.949 h -82.046 v 4.298 h 82.046 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path66",
    style: {
      fill: "current",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 406.073,439.195 h -82.046 v 4.298 h 82.046 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path68",
    style: {
      fill: "current",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 406.073,420.442 h -82.046 v 4.297 h 82.046 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path70",
    style: {
      fill: "current",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 406.073,401.688 h -82.046 v 4.297 h 82.046 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path72",
    style: {
      fill: "current",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 406.073,382.935 h -82.046 v 4.298 h 82.046 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path74",
    style: {
      fill: "current",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 406.073,364.182 h -82.046 v 4.298 h 82.046 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path76",
    style: {
      fill: "current",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 406.073,345.428 h -82.046 v 4.298 h 82.046 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path78",
    style: {
      fill: "current",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 406.073,326.675 h -82.046 v 4.298 h 82.046 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path80",
    style: {
      fill: "current",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 406.073,307.921 h -82.046 v 4.298 h 82.046 z"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCarClipboard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/car_clipboard.38153d40.svg";
export { ForwardRef as ReactComponent };